import { apiFetch, apiUpload } from "./client";
import type { SourceEntry, SourceCreateRequest, SourcePatchRequest } from "../types";

export async function fetchSources(): Promise<SourceEntry[]> {
  return apiFetch<SourceEntry[]>("/sources");
}

export async function createSource(data: SourceCreateRequest): Promise<SourceEntry> {
  return apiFetch<SourceEntry>("/sources", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateSource(id: number, data: SourcePatchRequest): Promise<SourceEntry> {
  return apiFetch<SourceEntry>(`/sources/${id}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export async function deleteSource(id: number): Promise<void> {
  await apiFetch<void>(`/sources/${id}`, { method: "DELETE" });
}

export async function uploadSourceLogo(id: number, file: File): Promise<SourceEntry> {
  const formData = new FormData();
  formData.append("file", file);
  return apiUpload<SourceEntry>(`/sources/${id}/logo`, formData);
}

export async function deleteSourceLogo(id: number): Promise<void> {
  await apiFetch<void>(`/sources/${id}/logo`, { method: "DELETE" });
}
